module.exports = __webpack_public_path__ + "img/flecha-voltar.35e971d4.svg";